export default __webpack_public_path__ + "static/media/IndividualFile.e9090913.svg";